import React from 'react';
import {
  Stack,
  Pagination
} from '@shopify/polaris';

function Pager(props) {

  const pageSize = 50;
  let pageCount = parseInt(props.totalResources / pageSize);

  if (props.totalResources % 50 > 0) {
    pageCount++;
  }

  return (
    <Stack alignment="center" distribution="center">
      <Pagination
        label={`Page ${props.currentPage} of ${pageCount}`}
        hasPrevious={props.disabled ? false : props.currentPage > 1}
        hasNext={props.disabled ? false : props.currentPage < pageCount}
        onPrevious={props.onPrevious}
        onNext={props.onNext}
      />
    </Stack>
  );

}

export default Pager;